// extracted by mini-css-extract-plugin
export default {"FloatIcon":"styles_FloatIcon__xCBgA"};